import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { AlwaysRootGuard } from './core/guards/always-root.guard';
import { AccessDeniedComponent } from './core/shell/access-denied/access-denied.component';

const ROUTES: Routes = [
	{
		path: '',
		loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule),
		canActivate: [MsalGuard, AlwaysRootGuard],
	},
	{
		path: 'access-denied',
		component: AccessDeniedComponent,
	},
	{
		path: 'auth',
		component: MsalRedirectComponent,
	},
	{
		path: '**',
		redirectTo: '',
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(ROUTES)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
